/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const SEQUENCE_LIST_STRINGS = {
  addAnotherStep: 'Add step',
  dragHandle: 'Drag handle for item',
  dragToChangeOrder: 'Drag this item to change the sequence order',
  minimumAmountOfSteps: 'Minimum amount of steps is {{count}}. You can not remove this step.',
  pressSpaceToLift: 'Press space bar to lift the item',
  removeStep: 'Remove step',
  reorder: 'Reorder',
  twoStepsRequired: 'A minimum of two steps is required to change step order.',
};
